import {
  CalendarTodayOutlined,
  LocationOnOutlined,
  PhoneOutlined,
} from '@mui/icons-material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {
  Avatar,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
  Typography} from '@mui/material';
import { CaleculateAge } from 'components/helpers';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import * as React from 'react';

const StyledButton = styled(Button)({
  boxShadow: 'none',
  borderRadius: 0,
  color: '#ffffff',
  width: '100%',
});

function PatientInfo(props) {
 
  const {
    patient_first_name: first_name,
    patient_last_name: last_name,
    patient_second_name: seond_name,
    patient_phone_number: phone_number,
    patient_birthday: birthdate,
    patient_city: city,
    patient_address: address,
    patient_gender: gender
  } = props;
 
  let calculatedAge = CaleculateAge(birthdate);
  calculatedAge = `${calculatedAge.year}.${calculatedAge.month}`;
  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid
          container
          alignItems={'center'}
          spacing={{ xs: 2, md: 0 }}
          justifyContent="space-between"
        >
          <Grid item xs={12} md={10}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {Localization.translate['patient_records']}
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            {/* add notes button */}
            {/* <StyledButton startIcon={<AddOutlined />} variant="contained">
              {Localization.translate['add_notes']}
            </StyledButton> */}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          background: '#F4F9FC',
          marginTop: '5rem',
          borderTopLeftRadius: '1rem',
          borderTopRightRadius: '1rem',
        }}
      >
        <Grid item xs={12}>
          <Grid container gap={2}>
            <Grid item xs={12}>
              <Avatar
                sx={{
                  width: '9rem',
                  height: '9rem',
                  margin: '0 auto',
                  marginTop: '-4.5rem',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ textAlign: 'center', fontWeight: 'bold',display:'flex',justifyContent:'center',gap:0 }}>
                <PersonOutlineOutlinedIcon sx={{ color: !Boolean(gender) ? '#ff69b4' : '#279bff', mr: 1 }} />
                {first_name &&
                  `${first_name || ''} ${seond_name || ''} ${last_name || ''}`} 
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <List spacing={1}>
                {phone_number && (
                  <ListItem alignItems="center">
                    <ListItemIcon sx={{ justifyContent: 'center' }}>
                      <PhoneOutlined sx={{ color: '#279BFF' }} />
                    </ListItemIcon>
                    <ListItemText dir="ltr">{phone_number}</ListItemText>
                  </ListItem>
                )}
                {birthdate && (
                  <ListItem alignItems="center">
                    <ListItemIcon sx={{ justifyContent: 'center' }}>
                      <CalendarTodayOutlined sx={{ color: '#279BFF' }} />
                    </ListItemIcon>
                    <ListItemText>
                      {dayjs(birthdate).format('MM/DD/YYYY')}
                      <small> ({calculatedAge})</small>
                    </ListItemText>
                  </ListItem>
                )}

                {city && (
                  <ListItem alignItems="center">
                    <>
                      <ListItemIcon sx={{ justifyContent: 'center' }}>
                        <LocationOnOutlined sx={{ color: '#279BFF' }} />
                      </ListItemIcon>
                      <ListItemText>
                        {`${address || ''} ${city ? `, ${city}` : ``}`}
                      </ListItemText>
                    </>
                  </ListItem>
                )}
              </List>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PatientInfo;
